import { TablePaginationConfig } from 'antd';
import { SorterResult } from 'antd/es/table/interface';
import { SortOrderEnum } from '../features/common/enum';
import { ITableParams } from '../stores';

export function handleCommonTableChange<T>(
  pagination: TablePaginationConfig,
  sorter: SorterResult<T> | SorterResult<T>[],
  // объект с полями, которые нужно обновить (page, limit, sortField, sortOrder)
  params: ITableParams,
  // коллбэк для загрузки
  fetchCallback?: () => void,
): void {
  const { current: page, pageSize } = pagination;
  const newSorter = Array.isArray(sorter) ? sorter[0] : sorter;
  const { field: sortField, order: sortOrder } = newSorter;

  // Обновляем ваши "общие" параметры
  params.page = page ?? 1;
  params.limit = pageSize ?? 10; // на случай, если pageSize может быть undefined
  params.sortField = sortField as string;
  params.sortOrder = sortOrder === 'ascend' ? SortOrderEnum.ASC : SortOrderEnum.DESC;

  // Вызываем коллбэк (getUsers, getAllNews, etc)
  fetchCallback?.();
}

export const initTableParams: ITableParams = {
  page: 1,
  limit: 20,
  sortField: 'createdAt',
  sortOrder: SortOrderEnum.DESC,
};
